import '../10. Battle/Library/LibraryBoxBattle.scss'
import NP from "../1. Core/NP";
import Control from "../1. Core/Control";
import ListGroupHeader from "../1. Core/Controls/ListBox/ListGroupHeader";
import Delegate from "../1. Core/Delegate";
import IconSelect from "../1. Core/Controls/Select/IconSelect";
import {getCountries, getStates, getTournaments, getWeights, getWeightString, ITournament, Weight} from "../10. Battle/Util";
import {IState} from "./StatesList";
import {EventTournament, SportType} from "../10. Battle/types";
import {ServerAPI} from "../1. Core/ServerAPI";
import DateInput from "../1. Core/Controls/DateInput/DateInput";
import moment = require("moment");

export default class AthletesRatingFilterPanel extends Control {

	public EvFilterSortChanged: Delegate;

	private _tournamentCombo: IconSelect;
	private _countryCombo: IconSelect;
	private _stateCombo: IconSelect;
	private _genderCombo: IconSelect;
	private _weightCombo: IconSelect;
	private _sortFieldCombo: IconSelect;
	private _sortDirectionCombo: IconSelect;
	private _TType: SportType;
	private _valueCombo: IconSelect;
	private _eventCombo: IconSelect;
	private _startDateInput: DateInput;
	private _endDateInput: DateInput;

	_initFields(settings: object)
	{
		this.EvFilterSortChanged = new Delegate();
		this._TType = SportType.MMA;
		super._initFields(settings);
	}

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_render()
	{
		this._initComponent('<div class="filter-panel"></div>');

		new ListGroupHeader({
			ParentNode: this._root,
			RK: 'Parameters',
			Class: 'app-list-group__subheader--accent'
		});

		this._valueCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Parameter'),
			SelectedIndex: 0,
			Items: [{
				Value: 'Strikes',
				FontImage: NP.FontImages.measure,
				Content: NP.RM.getString('Strikes')
			}, {
				Value: 'LandedStrikes',
				FontImage: NP.FontImages.measure,
				Content: NP.RM.getString('LandedStrikes')
			},

				{
					Value: 'BoutsCount',
					FontImage: NP.FontImages.measure,
					Content: NP.RM.getString('BoutsCount')
				}, {
					Value: 'Wins',
					FontImage: NP.FontImages.measure,
					Content: NP.RM.getString('Wins')
				},

				{
					Value: 'SubmissionTotal',
					FontImage: NP.FontImages.measure,
					Content: NP.RM.getString('SubmissionTotal')
				}, {
					Value: 'SubmissionSuccess',
					FontImage: NP.FontImages.measure,
					Content: NP.RM.getString('SubmissionSuccess')
				},

				{
					Value: 'TakedownCount',
					FontImage: NP.FontImages.measure,
					Content: NP.RM.getString('TakedownCount')
				}, {
					Value: 'TakedownCountSuccess',
					FontImage: NP.FontImages.measure,
					Content: NP.RM.getString('TakedownCountSuccess')
				},

				{
					Value: 'StrikesPerMin',
					FontImage: NP.FontImages.measure,
					Content: NP.RM.getString('StrikesPerMin')
				}, {
					Value: 'StrikesLandedPerMin',
					FontImage: NP.FontImages.measure,
					Content: NP.RM.getString('StrikesLandedPerMin')
				},


				{
					Value: 'TakedownCountAvg5',
					FontImage: NP.FontImages.measure,
					Content: NP.RM.getString('TakedownCountAvg5')
				},
				{
					Value: 'TakedownCountSuccessAvg5',
					FontImage: NP.FontImages.measure,
					Content: NP.RM.getString('TakedownCountSuccessAvg5')
				},
				{
					Value: 'SubmissionCountAvg5',
					FontImage: NP.FontImages.measure,
					Content: NP.RM.getString('SubmissionCountAvg5')
				},
				{
					Value: 'SubmissionCountSuccessAvg5',
					FontImage: NP.FontImages.measure,
					Content: NP.RM.getString('SubmissionCountSuccessAvg5')
				},
				{
					Value: 'EfStrikes',
					FontImage: NP.FontImages.measure,
					Content: NP.RM.getString('EfStrikes')
				},
				{
					Value: 'IntensityStrikes',
					FontImage: NP.FontImages.measure,
					Content: NP.RM.getString('IntensityStrikes')
				}
			],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._tournamentCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Tournaments'),
			SelectedIndex: 0,
			Items: [{
				Value: null,
				FontImage: NP.FontImages.event,
				Content: NP.RM.getString('AllTournaments')
			}],
			EvItemSelected: async () =>
			{
				await this.updateEvents();
				this._applyFiltersSort();
			}
		});

		this._eventCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Event'),
			EvItemSelected: () => this._applyFiltersSort()
		});

		let allItem = {
			Value: null as any,
			FontImage: NP.FontImages.geo,
			Content: NP.RM.getString('All')
		};

		this._countryCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Country'),
			SelectedIndex: 0,
			Items: [allItem],
			EvItemSelected: () =>
			{

				if (this._countryCombo.getValue())
					{ // @ts-ignore
						getStates(this._countryCombo.getValue()).then((res: IState[]) =>
											{
												if (this._stateCombo)
												{
													let items = res.map(state => ({
														Value: state.Id,
														FontImage: NP.FontImages.geo,
														Content: state.Name
													}));

													this._stateCombo.setItems([allItem, ...items]);
													this._stateCombo.setValue(null, false);
												}
											});
					}
				else
				{
					this._stateCombo.setItems([allItem]);
				}
				this._applyFiltersSort()
			}
		});

		this._stateCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('State'),
			SelectedIndex: 0,
			Items: [{
				Value: null,
				FontImage: NP.FontImages.geo,
				Content: NP.RM.getString('All')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._genderCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Gender'),
			SelectedIndex: 0,
			Items: [{
				Value: 'All',
				FontImage: NP.FontImages.gender,
				Content: NP.RM.getString('All')
			}, {
				Value: 1,
				FontImage: NP.FontImages.gender,
				Content: NP.RM.getString('MaleGender')
			}, {
				Value: 0,
				FontImage: NP.FontImages.gender,
				Content: NP.RM.getString('FemaleGender')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._weightCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('WeightCategory'),
			SelectedIndex: 0,
			Items: [{
				Value: null,
				FontImage: NP.FontImages.weight,
				Content: NP.RM.getString('All')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._startDateInput = new DateInput({
			ParentNode: this._root,
			FloatingLabel: "Start Date",
			FontImage: NP.FontImages.event,
			EvChanged: () => this._applyFiltersSort()
		});

		this._endDateInput = new DateInput({
			ParentNode: this._root,
			FloatingLabel: "End Date",
			FontImage: NP.FontImages.event,
			EvChanged: () => this._applyFiltersSort()
		});

		new ListGroupHeader({
			ParentNode: this._root,
			RK: 'OrderBy',
			Class: 'app-list-group__subheader--accent'
		});

		this._sortFieldCombo = new IconSelect({
			ParentNode: this._root,
			SelectedIndex: 3,
			Items: [{
				Value: 'Name',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('SortByName')
			}, {
				Value: 'Country',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('Country')
			}, {
				Value: 'Weight',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('SortByWeight')
			}, {
				Value: 'Value',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('RatingValue')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._sortDirectionCombo = new IconSelect({
			ParentNode: this._root,
			SelectedIndex: 0,
			Items: [{
				Value: -1,
				FontImage: NP.FontImages.arrow_downward,
				Content: NP.RM.getString('Desc')
			}, {
				Value: 1,
				FontImage: NP.FontImages.arrow_upward,
				Content: NP.RM.getString('Asc')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._renderItems([this._root], this._ParentNode || document.documentElement);
		this._loadFilters();
	}

	private async updateEvents()
	{
		if (this._eventCombo && this._tournamentCombo?.getValue())
		{
			let response = await ServerAPI.callUiApi("/t-events", {
				TournamentId: this._tournamentCombo.getValue(),
				Count: 500
			}, 'POST') as { List: EventTournament[] };

			//let events = await ServerAPI.call("SportService.getTournamentEvents", [this._tournamentCombo.getValue()]) as EventTournament[];
			let items = response.List.map(s => ({Value: s, FontImage: NP.FontImages.event, Content: s.Name})),
				 defaultItems = [{Value: null as any, FontImage: NP.FontImages.event, Content: NP.RM.getString('All')}];


			this._eventCombo.clear();
			this._eventCombo.addItems(defaultItems);
			this._eventCombo.addItems(items);
			this._eventCombo.setSelectedIndex(0, false);
		}
	}

	_loadFilters()
	{
		getWeights({Type: this._TType}).then((res: Weight[]) =>
		{
			let items = res.map(w => ({Value: w.Id, FontImage: NP.FontImages.weight, Content: getWeightString(w)}));
			this._weightCombo.addItems(items);
		});

		getTournaments(this._TType).then((res: ITournament[]) =>
		{
			if (this._tournamentCombo)
			{
				let items = res.map(t => ({Value: t.Id, FontImage: NP.FontImages.event, Content: t.Name}));
				this._tournamentCombo.addItems(items);
			}
		});

		getCountries(false).then((res: IState[]) =>
		{
			let items = res.map(state => ({Value: state.Id, FontImage: NP.FontImages.geo, Content: state.Name}));
			if (this._countryCombo)
				this._countryCombo.addItems(items);
		});

		this.updateEvents();
	}

	_applyFiltersSort()
	{
		this.EvFilterSortChanged.fire(this, this.getFilterData())
	}

	getFilterData()
	{
		return {
			CountryId: this._countryCombo.getValue(),
			StateId: this._stateCombo.getValue(),
			Sex: this._genderCombo.getValue() == 'All' ? null : this._genderCombo.getValue(),
			WeightCategory: this._weightCombo.getValue(),
			SortField: this._sortFieldCombo.getValue() == 'Value' ? this._valueCombo.getValue() : this._sortFieldCombo.getValue(),
			SortDirection: this._sortDirectionCombo.getValue(),
			TournamentId: this._tournamentCombo.getValue(),
			EventId: this._eventCombo.getValue() && this._eventCombo.getValue().Id,
			ShowValue: this._valueCombo.getValue(),
			StartDate: this._startDateInput.getValue() ? moment(this._startDateInput.getValue()).format('YYYY-MM-DD') : null,
			EndDate: this._endDateInput.getValue() ? moment(this._endDateInput.getValue()).format('YYYY-MM-DD') : null,
		}
	}

	setSortValues(sortField: string, sortDirection: number)
	{
		if (this._sortFieldCombo.getItems().find(itm => itm.Value == sortField))
			this._sortFieldCombo.setValue(sortField, false);
		else
			this._sortFieldCombo.setValue('Value', false);
		this._sortDirectionCombo.setValue(sortDirection, false);
	}

	getValueColumnName()
	{
		return this._valueCombo.getSelectedItem().Content;
	}
}